const isWindowAboveWidth = (width: string) => window.innerWidth >= parseInt(width);

export default isWindowAboveWidth;
